module.exports = __webpack_public_path__ + "static/media/success.dde72eb0.gif";